import qs from "qs";
import { quizData, DEFAULT_QUIZ } from "../constants";

export function ucwords(words) {
    const arr = words.toLowerCase().split(' ');
    const data = [];
    if (arr.length > 0) {
        arr.forEach((str) => {
            let newString = [...str];
            if (newString.length > 0) {
                newString[0] = str[0].toUpperCase();
                data.push(newString.join(''));
            }
        })
    }
    return data.join(' ');
}

export function currencyFormat(data) {
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    });
    return formatter.format(data);
}

// this will get the layout that will used for onboarding before the exam
export function getLayout(learnerState) {
    let { quizId } = qs.parse(window.location.search, {
		ignoreQueryPrefix: true,
	});
    
    if (typeof learnerState != "undefined" 
            && typeof learnerState == "object" 
            && (typeof learnerState.testLevel != "undefined" 
                || 
                    (typeof learnerState?.details != "undefined" && learnerState?.details !== null)
                )
        )  {
        quizId = learnerState.testLevel ?? learnerState?.details?.testLevel;
    }

    // // if quizId is not equal to acsf3shortcourse, acsf3, acsf4, vfh
    if (
        quizId !== "acsf3shortcourse" &&
        quizId !== "acsf3" && 
        quizId !== "acsf4" &&
        quizId !== "vfh"
    ) {
        quizId = DEFAULT_QUIZ; // use DEFAULT_QUIZ constant instead of hardcoded value
    }

	const layout = quizData[quizId ?? DEFAULT_QUIZ].layout;

    return layout;
}

export function floatOnly(value) {
    const regex = /^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$/;

    if (regex.test(value)) {
        return value;
    }
    return false;

}

export function setPageTitle(quizId) {
    let pageTitle =  '';
    switch(quizId) {
        case 'acsf4':
            pageTitle = 'ACSF4';
            break;
        case 'vfh':
                pageTitle = 'VFH';
                break;
        default: 
            pageTitle = 'ACSF3';
            break;
    }

    return `LLN Quiz - ${pageTitle} Course`;
}